import { render, staticRenderFns } from "./Index.vue?vue&type=template&id=f1c61278&lang=pug"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f1c61278')) {
      api.createRecord('f1c61278', component.options)
    } else {
      api.reload('f1c61278', component.options)
    }
    module.hot.accept("./Index.vue?vue&type=template&id=f1c61278&lang=pug", function () {
      api.rerender('f1c61278', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/admin/orders/default/reports/Index.vue"
export default component.exports